(function () {
	'use strict';

	angular.module('KimaMain').directive('agencyMap', agencyMap);

	agencyMap.$inject = [];

	function agencyMap() {
		return {
			restrict: 'E',
			template: '<div class="agency-map" id="agency-map" style="height: 400px; margin-bottom: 60px;"></div>',
			scope: {
				coords: '=',
				zoom: '='
			},
			link: function(scope, elem) {
				if (!scope.coords) {
					return;
				}

				function initMap() {
					var map = new google.maps.Map(document.getElementById('agency-map'), {
						zoom: scope.zoom || 17
					});
					var marker = new google.maps.Marker({
						map: map,
						position: scope.coords
					});
					map.setCenter({lat: scope.coords.lat, lng: scope.coords.lng});
				}

				initMap();
			}
		};
	}

})();

